import { ArrowLeftRight, Eye, Link2, Pencil } from "lucide-react";

import { RowMenu } from "@/components/kit";
import { Product } from "@/types";

export interface ActionsCellProps {
  product: Product;
  onEdit: () => void;
  onView: () => void;
  onChangePrimary: () => void;
  onViewLinked?: () => void;
}

export function ActionsCell({
  product,
  onEdit,
  onView,
  onChangePrimary,
  onViewLinked,
}: ActionsCellProps) {
  return (
    <RowMenu
      label="Product actions"
      items={[
        {
          id: "edit",
          label: "Edit Product",
          icon: <Pencil className="size-4" />,
          onAction: onEdit,
        },
        {
          id: "view",
          label: "View Details",
          icon: <Eye className="size-4" />,
          onAction: onView,
        },
        {
          id: "change-primary",
          label: "Change Primary",
          icon: <ArrowLeftRight className="size-4" />,
          onAction: onChangePrimary,
        },
        ...(product.scrapedProduct && onViewLinked
          ? [
              {
                id: "view-linked",
                label: "View Linked",
                icon: <Link2 className="size-4" />,
                onAction: onViewLinked,
              },
            ]
          : []),
      ]}
    />
  );
}
